<template>
  <div id="map-data">
    <div  id="map-data-content">
      <video-data v-show="showVideo" ref="VideoData" @showMapBar="MapInfo"/>
      <div id="tmapContainer" v-show="showMap" class="box"></div>
    </div>

    <div class="bottom">
      <div class="bottom-topContainer">
        <div class="bottom-topContainer-name">
          <div class="bottom-topContainer-value">设备名称</div>
        </div>
        <div class="bottom-topContainer-name">
          <div class="bottom-topContainer-value">{{deviceName}}</div>
        </div>
        <div class="bottom-topContainer-name">
          <div class="bottom-topContainer-value">设备地址码</div>
        </div>
        <div class="bottom-topContainer-name">
          <div class="bottom-topContainer-value">{{deviceAddr}}</div>
        </div>
      </div>
      <div class="bottom-middleContainer">
        <div class="bottom-middleContainer-name">
          <div class="bottom-middleContainer-value">设备状态</div>
        </div>
        <div class="bottom-middleContainer-name">
          <div class="bottom-middleContainer-value">{{deviceStatus}}</div>
        </div>
        <div class="bottom-middleContainer-name">
          <div class="bottom-middleContainer-value">设备类型</div>
        </div>
        <div class="bottom-middleContainer-name">
          <div class="bottom-middleContainer-value">{{deviceType}}</div>
        </div>
      </div>
      <div class="bottom-footContainer">
        <div class="bottom-footContainer-name">
          <div class="bottom-footContainer-value">设备纬度</div>
        </div>
        <div class="bottom-footContainer-name">
          <div class="bottom-footContainer-value">{{deviceLat}}</div>
        </div>
        <div class="bottom-footContainer-name">
          <div class="bottom-footContainer-value">设备经度</div>
        </div>
        <div class="bottom-footContainer-name">
          <div class="bottom-footContainer-value">{{deviceLng}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VideoData from "./VideoData";
  import {getAttributesServer} from "../../until/api/MeteSoil";
  import moment from 'moment'
  export default {
    name: 'MapData',
    components: {
      VideoData
    },
    data() {
      return {
        map: '',
        markList:[], //全部点
        markers:[],
        showVideo: false,
        showMap: true,
        mapDeviceList: [],
        mapSPDevice: [],
        deviceName: '-',
        deviceAddr: '-',
        deviceStatus: '-',
        deviceType: '-',
        deviceLat: '-',
        deviceLng: '-',
      }
    },

    mounted() {
      this.loadTianditu();
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority'))  : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')): this.$route.params.customerId;
      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {//获取气象墒情设备
        if(deviceList.data.length > 0) {
          for(let i = 0; i < deviceList.data.length; i++) {
            let deviceJson = {};
            deviceJson.id = deviceList.data[i].id.id;
            deviceJson.name = deviceList.data[i].name;
            deviceJson.type = deviceList.data[i].id.entityType;
            that.mapDeviceList.push(deviceJson);
          }
        }
        that.setServiceOption(0, that.mapDeviceList.length); //使用递归方法获取每个墒情设备的设备信息
      })
    },

    methods: {
      loadTianditu() {
        if (typeof T !== 'undefined') {
          this.initMap();
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=b605394410079145db1525d2c8fa27aa';
        script.onload = () => {
          setTimeout(() => this.initMap(), 50);
        };
        document.body.appendChild(script);
      },

      initMap() {
        try {
          const center = new T.LngLat(103.817535, 36.132308);
          this.map = new T.Map('tmapContainer');
          this.map.centerAndZoom(center, 4);
          this.map.enableScrollWheelZoom();
          if (typeof TMAP_SATELLITE_MAP !== 'undefined' && this.map.setMapType) {
            this.map.setMapType(TMAP_HYBRID_MAP);
          }
          this.addCustomControls();

          document.getElementsByClassName("tdt-control-copyright tdt-control")[0].style.display = 'none'
        } catch (e) {
          console.error('initMap error', e);
        }

      },

      addCustomControls() {
        const that = this;
        const Vedio = T.Control.extend({
          options: {
            position: T_ANCHOR_TOP_LEFT,
            offset: new T.Point(10, 10)
          },

          onAdd: function (map) {
            const div = document.createElement("img");
            div.style.cursor = "pointer";
            div.src = require('../img/video.png');
            div.style.width = "36px";
            div.style.height = "36px";

            div.onclick = function () {
              that.showMap = false;
              that.showVideo = true;
            };

            map.getContainer().appendChild(div);
            return div;
          },
        });

        this.map.addControl(new Vedio());
      },

      /**
       * 获取气象墒情设备的信息
       * @param j
       * @param length
       */
      setServiceOption(j, length) {
        if(this.mapDeviceList[j] == undefined) return;
        getAttributesServer(this.mapDeviceList[j].type, this.mapDeviceList[j].id).then(response => {
          let option = { "deviceName": this.mapDeviceList[j].name, "deviceAddr": this.mapDeviceList[j].name,
            "lat": 0, "lng": 0, "status": "", "deviceType": "meteSoil", "url": ""}; //设备信息json
          let beforeTime = new Date(moment().subtract(1, "hours")).getTime();//当前时间前一小时时间
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].key == 'latitude') { //判断当前变量是否为纬度
              option.lat = response.data[i].value;
            } else if(response.data[i].key == 'longitude') { //判断当前变量是否为经度
              option.lng = response.data[i].value;
            } else if(response.data[i].key == 'lastActivityTime') { //判断当前变量是否为最后一次连接时间
              if(response.data[i].value <= beforeTime) { //离线状态
                option.url = require("../img/offLine.png");
                option.status = "offline";
              } else { //在线状态
                option.url = require("../img/onLine.png");
                option.status = 'online'
              }
            } else if(response.data[i].key == 'fx') {
              option.deviceType = "fx";
            }
            if(i ==  response.data.length - 1) { //判断当前为最后一循环
              if(option.lat != 0 && option.lng != 0) { //如果经纬度为0 随机生成经纬度
                let existItem = this.markList.find(item => item.deviceName === option.deviceName);
                if (existItem) {
                  let index = this.markList.indexOf(existItem);
                  this.markList[index] = option;
                  this.updateMarker(option);
                } else {
                  this.markList.push(option);
                  this.addSingleMarker(option);
                }
                //this.setMapViewport();
              }
            }
          }

          if(++j < length) {
            this.setServiceOption(j, length);//使用递归方法获取每个墒情设备的设备信息
          } else {
            this.mapSPDeviceList();//获取虫情孢子设备地址
          }
        }).catch(error =>{
          console.log("error", error);
        })
      },

      /**
       * 获取虫情孢子设备地址
       */
      mapSPDeviceList() {
        let that = this;
        this.$SporeSoilCommon.getSpDeviceList(function (deviceList) {
          if(deviceList.code != 2000) {
            for(let i = 0; i < deviceList.data.length; i++) {
              if(deviceList.data[i].deviceType == 'spore') { //筛选出虫情孢子设备列表
                that.mapSPDevice.push(deviceList.data[i].deviceAddr);
              } else if(deviceList.data[i].deviceType.indexOf('worm') > -1) {
                that.mapSPDevice.push(deviceList.data[i].deviceAddr);
              }
            }

            that.setSporeWormOption(0, that.mapSPDevice.length); //使用递归方法 获取虫情孢子实时数据
          }
        })
      },

      /**
       * 使用递归方法 获取虫情孢子实时数据
       * @param j
       * @param length
       */
      setSporeWormOption(j ,length) {
        let that = this;
        this.$SporeSoilCommon.spRealDataTime(this.mapSPDevice[j], function (realDataList) {
          if(realDataList.data.length > 0) {
            //设备信息json
            let option = { "deviceName":  realDataList.data[0].deviceName, "deviceAddr": realDataList.data[0].deviceAddr,
              "lat": realDataList.data[0].lat, "lng": realDataList.data[0].lng, "status": realDataList.data[0].status, "deviceType": realDataList.data[0].deviceType, "url": ""};

            option.url = option.status == 'online' ?  require("../img/onLine.png") : require("../img/offLine.png"); //获取在线或者离线图标

            if(option.lat == 0 && option.lng == 0) { //如果经纬度为0 随机生成经纬度
              option.lat = Math.random() * 30 + 21;
              option.lng = Math.random() * 40 + 85;
            }
            let existItem = that.markList.find(item => item.deviceName === option.deviceName);
            if (existItem) {
              let index = that.markList.indexOf(existItem);
              that.markList[index] = option;
              that.updateMarker(option);
            } else {
              that.markList.push(option);
              that.addSingleMarker(option);
            }
            //that.setMapViewport();
          }

          if(++j < length) {
            that.setSporeWormOption(j, length);//使用递归方法获取每个虫情孢子设备的设备信息
          }
        });
      },

      addSingleMarker(item) {
        console.log("2222222")
        const point = new T.LngLat(item.lng, item.lat);
        const icon = new T.Icon({
          iconUrl: item.url,
          iconSize: new T.Point(22, 33),
          iconAnchor: new T.Point(11, 33)
        });
        const marker = new T.Marker(point, { icon });
        marker.device = item.device;

        marker.addEventListener('click', async () => {
          this.infoWindowOpen(item);
        });

        this.map.addOverLay(marker);
        this.markers.push(marker);
      },

      updateMarker(option) {
        const marker = this.markers.find(m => m.device.id === option.device.id);
        if (marker) {
          console.log("111111")
          const point = new T.LngLat(option.lng, option.lat);
          marker.setLngLat(point);
          marker.setIcon(new T.Icon({
            iconUrl: option.url,
            iconSize: new T.Point(22, 33),
            iconAnchor: new T.Point(11, 33)
          }));
        }
      },

      setMapViewport() {
        if (!this.map || this.markList.length === 0) return;

        const points = this.markList
          .map(m => ({
            lng: Number(m.lng),
            lat: Number(m.lat)
          }))
          .filter(p => !isNaN(p.lng) && !isNaN(p.lat))
          .map(p => new T.LngLat(p.lng, p.lat));

        if (points.length === 0) return;

        const view = this.map.getViewport(points);

        console.log("viewport:", view);

        this.map.centerAndZoom(view.center, view.zoom);
      },
      /**
       * 点击小图标显示设备信息
       * @param marker
       */
      infoWindowOpen (marker) {
        this.deviceName = marker.deviceName; //设备名
        this.deviceAddr = marker.deviceAddr; //设备地址
        this.deviceStatus = marker.status == 'online' ? '在线' : '离线'; //设备状态
        // this.deviceType = marker.deviceType == 'meteSoil' ? '气象墒情' : (marker.deviceType == 'spore' ? '孢子' : '虫情'); //设备类型
        if(marker.deviceType == 'meteSoil') {
          this.deviceType = "气象墒情";
        } else if(marker.deviceType == 'fx') {
          this.deviceType = "杀虫灯";
        } else if (marker.deviceType == 'spore') {
          this.deviceType = "孢子";
        } else {
          this.deviceType = "虫情";
        }
        this.deviceLat = parseFloat(marker.lat).toFixed(6); //纬度
        this.deviceLng = parseFloat(marker.lng).toFixed(6); //经度
      },

      /**
       * 切换到摄像头画面
       * @param data
       * @constructor
       */
      MapInfo(data) {
        this.showVideo = false;
        this.showMap = true;
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../less/MapData";
</style>



// WEBPACK FOOTER //
// src/components/view/MapData.vue